
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  getImageAttribution,
  getImageOrientation
} from "@/futurelayer/images/dimensions";
import { UnsplashImage } from "../../../futurelayer/api/unsplash";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon
  }
})
export default class FutureImageThumbnail extends Vue {
  @Prop({ required: true }) image!: UnsplashImage;

  isLoading = true;

  showAttributionOverlay = false;

  handleLoad() {
    this.isLoading = false;
  }

  handleError() {
    this.isLoading = false;
  }

  get classes() {
    return {
      "image-card": true,
      "image-card--loading": this.isLoading,
      "image-card--landscape": getImageOrientation(this.image) === "landscape",
      "image-card--portrait": getImageOrientation(this.image) === "portrait",
      "image-card--square": getImageOrientation(this.image) === "square"
    };
  }

  get attribution() {
    return getImageAttribution(this.image);
  }
}
